import { brazeConfig } from 'config/braze.config'

const initializeBraze = (appboy: any): Promise<any> => {
  const brazeENV = brazeConfig[process.env.REACT_APP_ENV || 'prod']
  const BRAZE_API_KEY = brazeENV.apiKey
  const BRAZE_SDK_ENDPOINT = brazeENV.endpoint
  const BRAZE_SAFARI_WESITE_PUSH_ID = brazeENV.safariPushId

  // initialize the SDK
  return new Promise((resolve, reject) => {
    if (!appboy) {
      return reject(new Error('Error: appboy is undefind'))
    }
    try {
      const initialized = appboy.initialize(BRAZE_API_KEY, {
        baseUrl: BRAZE_SDK_ENDPOINT,
        serviceWorkerLocation: '/sw.js',
        safariWebsitePushId: BRAZE_SAFARI_WESITE_PUSH_ID,
        enableLogging: brazeENV.enableLogging,
        enableHtmlInAppMessages: true
      })
      if (!initialized) {
        return reject(new Error('Error: appboy not initilized'))
      }
    } catch (err) {
      return reject(new Error('Error: appboy not initilized'))
    }

    // optionally show all In-App Messages without custom handling
    appboy.display.automaticallyShowNewInAppMessages()

    // Whether or not the user has blocked push.
    // If the user has blocked push, they cannot be prompted to register again, and must manually remove the block in order to receive push.
    // if (appboy.isPushSupported()) {
    //   if (appboy.isPushPermissionGranted()) {
    //     console.log('appboy Push Permission Granted')
    //   } else {
    //     console.log('appboy Push not Permission Granted')
    //   }
    //   appboy.registerAppboyPushMessages(
    //     () => console.log('appboy Push Message Registered'),
    //     (temporaryDenial: boolean) => {
    //       console.log('appboy  Push Messages not  Registered', temporaryDenial)
    //     }
    //   )
    // }

    // Start Session.
    appboy.openSession()
    return resolve({ appboy })
  })
}

const Braze = {
  initializeBraze
}
export default Braze
